module.exports = __webpack_public_path__ + "8431e1fb650addb5654e38e9018ee4b7.svg";